class Overlay {
  onToggle(element) {
    element.classList.toggle('menu--main__overlay');
  }
}

export default Overlay;
